import { render, staticRenderFns } from "./safeLeft.vue?vue&type=template&id=dfa5da04&scoped=true&"
import script from "./safeLeft.vue?vue&type=script&lang=js&"
export * from "./safeLeft.vue?vue&type=script&lang=js&"
import style0 from "./safeLeft.vue?vue&type=style&index=0&id=dfa5da04&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dfa5da04",
  null
  
)

component.options.__file = "safeLeft.vue"
export default component.exports